    <div class="toolbar d-flex flex-wrap align-items-center">
        <div class="d-flex flex-wrap coordinate-holder align-items-center justify-content-center">
            <div class="button me-1 pointer" (click)="rewind()">
                <fa-icon [icon]="iconsService.faIconsSolid.faBackward"></fa-icon>
            </div>
            <div class="d-flex">
                <div class="d-flex arrow-box align-items-center justify-content-center">
                    <fa-icon [icon]="iconsService.faIconsSolid.faArrowsLeftRight"></fa-icon>
                </div>
                <div *ngFor="let s of coordXList" class="d-flex coordinate-box align-items-center justify-content-center">
                    {{s}}
                </div>
            </div>
            <div class="mx-1">&nbsp;</div>
            <div class="d-flex">
                <div *ngFor="let s of coordYList" class="d-flex coordinate-box align-items-center justify-content-center">
                    {{s}}
                </div>
                <div class="d-flex arrow-box align-items-center justify-content-center">
                    <fa-icon [icon]="iconsService.faIconsSolid.faArrowsUpDown"></fa-icon>
                </div>
            </div>
            <div class="button ms-1 me-2 pointer" (click)="zoomOut()">
                <fa-icon [icon]="iconsService.faIconsSolid.faPlaneDeparture"></fa-icon>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <div class="toolbar-icon-btn d-flex mx-2 zoom-icon" (click)="changeZoom()">
                <fa-icon [icon]="iconsService.faIconsSolid.faMagnifyingGlassPlus"></fa-icon>
            </div>
            <div class="d-flex align-items-center">
                <div class="track-dot"></div>
                <input [(ngModel)]="zoomSlider" min="20" max="47" type="range" class="form-range mx-1" id="customRange1">
                <div class="track-dot"></div>
            </div>
        </div>
    </div>
